"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorPageTranslations = void 0;
var translations = _interopRequireWildcard(require("./translations"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const errorPageTranslations = exports.errorPageTranslations = {
  az: translations.azerbadjanTranslations,
  be: translations.belarusTranslations,
  bg: translations.BulgariaTranslations,
  bs: translations.bosniaTranslations,
  cs: translations.czechRepublicTranslations,
  da: translations.denmarkTranslations,
  de: translations.germanTranslations,
  el: translations.greeceTranslations,
  en: translations.englishTranslations,
  es: translations.latinAmericaTranslations,
  et: translations.estoniaTranslations,
  fi: translations.finlandTranslations,
  fr: translations.algeriaTranslations,
  hi: translations.hindiTranslations,
  hr: translations.croatiaTranslations,
  hu: translations.hungaryTranslations,
  hy: translations.armeniaTranslations,
  id: translations.indonesiaTranslations,
  it: translations.italyTranslations,
  ka: translations.georgiaTranslations,
  kk: translations.kazakhstanTranslations,
  ky: translations.kyrgystanTranslations,
  lt: translations.lithuaniaTranslations,
  lv: translations.latviaTranslations,
  mk: translations.macedoniaTranslations,
  mn: translations.mongoliaTranslations,
  my: translations.myanmarTranslations,
  nb: translations.norwayTranslations,
  nl: translations.hollandTranslations,
  pl: translations.polandTranslations,
  pt: translations.portugalTranslations,
  ro: translations.romaniaTranslations,
  ru: translations.cisTranslations,
  si: translations.sloveniaTranslations,
  sk: translations.slovakiaTranslations,
  sl: translations.sloveniaTranslations,
  sr: translations.serbiaTranslations,
  sv: translations.swedenTranslations,
  th: translations.thailandTranslations,
  tr: translations.turkeyTranslations,
  uk: translations.ukraineTranslations,
  uz: translations.uzbekTranslations,
  vi: translations.vietnamTranslations,
  zh: translations.chinaTranslations
};
